export default "__VITE_ASSET__DSQp5Wjb__"